/**
 * @generated SignedSource<<96c8896a573bf0a38a0dca31bdc9401d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRulesListItemUserPill$data = {
  readonly includeAllReports: boolean;
  readonly user: {
    readonly email: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly internalAttributes: {
      readonly allReports: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly fullName: string;
          };
        }>;
      } | null;
    } | null;
    readonly isGuest: boolean;
  };
  readonly " $fragmentType": "AutoRecordRulesListItemUserPill";
};
export type AutoRecordRulesListItemUserPill$key = {
  readonly " $data"?: AutoRecordRulesListItemUserPill$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemUserPill">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordRulesListItemUserPill",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeAllReports",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserInternalAttributes",
          "kind": "LinkedField",
          "name": "internalAttributes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserConnection",
              "kind": "LinkedField",
              "name": "allReports",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AutoRecordRuleUser",
  "abstractKey": null
};
})();

(node as any).hash = "599dc671fede004a785cbdb76fc36eac";

export default node;
